import { Grid, Typography } from '@mui/material';
import { FormikHelpers } from 'formik';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from '../../../core/ui/layout/Layout';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import { parseValidationErrors } from '../../../core/utils/validation';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import { JobEdit, Job } from '../job';
import ReturnButton from '../../../core/ui/utility/ReturnButton';
import Loader from '../../../core/ui/utility/Loader';
import EditJobForm from '../components/EditJobForm';

const EditJobContainer = () => {
  const { id, vacancyId } = useParams();
  const { callApi, loading: submitting } = useSendApiData();
  const { fetchData, loading } = useFetchApiData();
  const [job, setJob] = useState<Job | null>(null);

  const fetchJob = () =>
    fetchData(`auth-ea35a/jobs/${id}`, {
      onSuccess: (data: Job) => {
        // console.log({ data });
        setJob(data);
      },
    });

  useEffect(() => {
    fetchJob();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (
    values: JobEdit,
    { setFieldError }: FormikHelpers<JobEdit>
  ) => {
    let success = false;

    const formData: any = new FormData();
    Object.entries(values).forEach(([key, val]) => {
      if (val !== null) {
        formData.append(key, val as Blob);
      }
    });

    await callApi({
      endpoint: `auth-ea35a/jobs/${id}?_method=PATCH`,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        await fetchJob();
        toastMessage('Job Edited');
        success = true;
      },
    });

    return success;
  };

  return (
    <Layout
      renderLeftToolbar={() => (
        <ReturnButton to={`/vacancies/edit/${vacancyId}`} />
      )}
    >
      <Loader loading={loading || !job}>
        <Grid sx={{ p: 2 }}>
          <Grid container sx={{ mb: 1, px: 1 }}>
            <Typography variant="h5">View Job</Typography>
          </Grid>
          <EditJobForm
            job={job!}
            onSubmit={handleSubmit}
            submitting={submitting}
          />
        </Grid>
      </Loader>
    </Layout>
  );
};

export default EditJobContainer;
